export const onlyDigits = (value: string): string => value.replace(/\D/g, '');

// 000.000.000-00
export const maskCPF = (value: string): string => {
    const digits = onlyDigits(value).slice(0, 11);
    return digits
        .replace(/^(\d{3})(\d)/, '$1.$2')
        .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
        .replace(/^(\d{3})\.(\d{3})\.(\d{3})(\d)/, '$1.$2.$3-$4');
};

// (00) 0000-0000 para fixo e (00) 00000-0000 para celular
export const maskTelefone = (value: string): string => {
    const digits = onlyDigits(value).slice(0, 11);
    if (digits.length <= 2) {
        return digits.replace(/^(\d{1,2})/, '($1');
    }
    if (digits.length <= 6) {
        return digits.replace(/^(\d{2})(\d+)/, '($1) $2');
    }
    if (digits.length <= 10) {
        return digits.replace(/^(\d{2})(\d{4})(\d+)/, '($1) $2-$3');
    }
    return digits.replace(/^(\d{2})(\d{5})(\d+)/, '($1) $2-$3');
};

export const isValidCPF = (value: string): boolean => {
    const cpf = onlyDigits(value);
    if (cpf.length !== 11) return false;
    // Rejeita sequencias repetidas (00000000000, 11111111111, ...)
    if (/^(\d)\1{10}$/.test(cpf)) return false;

    const checkDigit = (length: number): number => {
        let sum = 0;
        for (let i = 0; i < length; i++) {
            sum += parseInt(cpf.charAt(i), 10) * (length + 1 - i);
        }
        const rest = (sum * 10) % 11;
        return rest === 10 || rest === 11 ? 0 : rest;
    };

    return checkDigit(9) === parseInt(cpf.charAt(9), 10) && checkDigit(10) === parseInt(cpf.charAt(10), 10);
};

export const isValidTelefone = (value: string): boolean => {
    const telefone = onlyDigits(value);
    return telefone.length === 10 || telefone.length === 11;
};

export const isValidEmail = (value: string): boolean => {
    const email = (value || '').trim();
    if (email.length > 254) return false;
    return /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)+$/.test(email);
};
